export const MILLISECONDS_PER_DAY = 60 * 60 * 24 * 1000; // 86400000
export const MILLISECONDS_PER_HOUR = 60 * 60 * 1000; // 3600000
export const MILLISECONDS_PER_MINUTE = 60 * 1000; // 60000
export const TIMEOUT_AFTER_MINUTES = 15;
export const TEN_SECONDS_IN_MILLISECONDS = 10 * 1000; // 10000
export const DATE_FORMAT = "MM/DD/YYYY";
export const DATE_FORMAT_TEMPLATE = "##/##/####";
export const DATE_INPUT_MASK = "_";
